<form [formGroup]="formGroup">

    <div class="fields-group">
        <div class="permissions-sets sets-list">
            <div class="head">
                <label style="color:#212529;">History</label>
                <button *ngIf="isMultiScope" (click)="onAddMainScope()" class="new-scope-btn" color="primary"
                    mat-raised-button type="button">
                    <svg height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5,8.667H10.333V4.5H8.667V8.667H4.5v1.667H8.667V14.5h1.667V10.333H14.5Z" fill="#fff"
                            id="plus" transform="translate(-4.5 -4.5)" />
                    </svg>
                    <span class="mx-2">Add</span>
                </button>
            </div>
            <div class="set-list" formArrayName="data">
                <div *ngFor="let mainScope of MainScopes.controls;let mainScopeIndex = index"
                    [class.collapsed]="activeIndex !== mainScopeIndex" class="set-item" [formGroupName]="mainScopeIndex"
                    [ngStyle]="{'border-color': (mainScope.invalid && (isSubmitted || MainScopes.value[mainScopeIndex].submitted) ) ? '#d70000':'#05438e'}">
                    <div (click)="toggleProcedure(mainScopeIndex)" class="set-head"
                        [class.has-error-label]="mainScope.invalid && (isSubmitted || MainScopes.value[mainScopeIndex].submitted)">
                        <div>
                            <span *ngIf="isMultiScope"> Main Scope {{ mainScopeIndex + 1 }}: </span>
                            <ng-container><span class="scope-input-title">{{
                                    mainScope.value.history_scope_name
                                    }}</span></ng-container>
                        </div>
                        <mat-icon class="more">unfold_more</mat-icon>
                        <mat-icon class="less">unfold_less</mat-icon>
                    </div>
                    <div class="set-content" [hidden]="activeIndex != mainScopeIndex">
                        <div class="row pb-3">
                            <div class="col-12">
                                <!-- <div class="create_content-document">Scope Name</div> -->
                                <mat-form-field appearance="outline" class="form-group">
                                    <mat-label>{{isMultiScope?"Scope Name":"Title"}}</mat-label>
                                    <input formControlName="history_scope_name" matInput maxlength="250" />
                                    <mat-error *ngIf="
                            mainScope.get('history_scope_name')
                              .errors?.required
                          ">
                                        Field is Required
                                    </mat-error>
                                    <mat-error *ngIf="mainScope.controls['history_scope_name'].hasError('maxlength')">
                                        Max 250 characters
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-12" formArrayName="history">
                                <div class="row mb-4" *ngIf="HistoryRecords(mainScopeIndex).controls.length > 0">

                                    <div class="col-12">
                                        <mat-accordion class="example-headers-align" [multi]="false" #accordion>
                                            <ng-container
                                                *ngFor="let historyRecord of HistoryRecords(mainScopeIndex).controls;let recordIndex = index"
                                                [formGroupName]="recordIndex">
                                                <mat-expansion-panel class="mb-3"
                                                    [ngStyle]="historyRecord.invalid && (historyRecord.touched || historyRecord.dirty || isSubmitted) ? {'border': '1.5px solid #d70000', 'box-shadow': '0 2px 8px rgba(60,60,60,0.12), 0 0.5px 1.5px rgba(60,60,60,0.08)', 'border-radius': '8px'} : {'box-shadow': '0 2px 8px rgba(60,60,60,0.12), 0 0.5px 1.5px rgba(60,60,60,0.08)', 'border-radius': '8px'}">
                                                    <mat-expansion-panel-header>
                                                        <mat-panel-title style="align-items: center;">
                                                            <span style="font-size: 0.92rem; font-weight: 500;">
                                                                History Record {{ recordIndex + 1 }}
                                                            </span>
                                                        </mat-panel-title>
                                                        <mat-panel-description
                                                            style="align-items: center;font-size: 0.92rem; font-weight: 500;">
                                                            {{ historyRecord.value.note ? (historyRecord.value.note |
                                                            slice:0:20) + (historyRecord.value.note.length > 20 ? '...'
                                                            :
                                                            '') : 'No Note' }}
                                                        </mat-panel-description>
                                                        <a class="ml-auto" style="margin-right: 10px;"
                                                            [hidden]="recordIndex == 0"
                                                            (click)="onDeleteHistoryRecord(mainScopeIndex,recordIndex); $event.stopPropagation();">
                                                            <img style="width: 15px;height: 15px;" alt=""
                                                                src="./assets/images/icons/delete-iconN.svg" />
                                                        </a>
                                                    </mat-expansion-panel-header>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <mat-form-field class="form-group">
                                                                <mat-label>Note</mat-label>
                                                                <textarea matInput formControlName="note"
                                                                    style="height: 60px;" maxlength="1000"></textarea>
                                                                <mat-error
                                                                    *ngIf="historyRecord.controls['note'].hasError('required')">
                                                                    Field is Required
                                                                </mat-error>
                                                                <mat-error
                                                                    *ngIf="historyRecord.controls['note'].hasError('maxlength')">
                                                                    Max 1000 characters
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="col-md-6 col-12">
                                                            <mat-form-field class="form-group">
                                                                <mat-label>Date</mat-label>
                                                                <input [matDatepicker]="HistoryDate"
                                                                    formControlName="date" matInput readonly />
                                                                <mat-datepicker-toggle [for]="HistoryDate"
                                                                    matSuffix></mat-datepicker-toggle>
                                                                <mat-datepicker #HistoryDate></mat-datepicker>
                                                                <mat-error
                                                                    *ngIf="historyRecord.controls['date'].hasError('required')">
                                                                    Field is Required
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>
                                                        <div class="col-md-6 col-12">
                                                            <mat-form-field class="form-group">
                                                                <mat-label>Issue Number</mat-label>
                                                                <input formControlName="issue_no" matInput
                                                                    maxlength="20" appOnlynumber />
                                                                <mat-error
                                                                    *ngIf="historyRecord.controls['issue_no'].hasError('required')">
                                                                    Field is Required
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </mat-expansion-panel>
                                            </ng-container>
                                        </mat-accordion>
                                    </div>


                                </div>
                                <div class="has-error"
                                    *ngIf="MainScopes.controls[mainScopeIndex].get('history').value?.length == 0 && ( MainScopes.controls[mainScopeIndex].get('history').touched || MainScopes.value[mainScopeIndex].submitted)">
                                    History records are required
                                </div>
                                <div class="col-12 mt-4">
                                    <button (click)="onAddHistoryRecord(mainScopeIndex)"
                                        class="new-scope-btn w-100 small" color="primary" mat-raised-button
                                        type="button">
                                        <svg height="10" viewBox="0 0 10 10" width="10"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M14.5,8.667H10.333V4.5H8.667V8.667H4.5v1.667H8.667V14.5h1.667V10.333H14.5Z"
                                                fill="#fff" id="plus" transform="translate(-4.5 -4.5)" />
                                        </svg>
                                        <span class="mx-2">Add History Record</span>
                                    </button>
                                </div>
                            </div>

                        </div>

                        <div class="set-actions">
                            <button (click)="onDeleteMainScope(mainScopeIndex)" mat-icon-button type="button"
                                *ngIf="MainScopes.controls.length>1">
                                <img alt="" src="./assets/images/icons/delete-iconN.svg" />
                            </button>
                            <div></div>
                            <button (click)="submitMainScope(mainScopeIndex)" color="primary" mat-raised-button
                                type="button">
                                <mat-icon>check</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="MainScopes.controls.length==0 && isSubmitted" class="has-error">Form is required</div>
        </div>
    </div>
</form>